import { render } from "./Erid.vue?vue&type=template&id=b44f111e"
import script from "./Erid.vue?vue&type=script&lang=js"
export * from "./Erid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__